module.exports = __webpack_public_path__ + "static/media/usps.67e2fb73.svg";